module.exports = __webpack_public_path__ + "static/img/img_7.187786a5.jpg";